<template>
    <div class="container-fluid">
        <div class="page-title">
            <h4>Modifier un outil</h4>
        </div>
        <form action="">
            <div class="form-group">
                <label>Sélectionnez l'outil à modifier : </label>
                <select class="form-control" v-model="system_selected" required>
                    <option v-bind:value="null" selected>Choisissez un outil</option>
                    <option v-for="system in systems" v-bind:value="system" v-bind:key="system.id">
                        {{system.name}} - Code : {{system.code}}
                    </option>
                </select>
            </div>
            <div class="mrg-top-5">
                <button type="button" class="btn btn-primary" v-bind:disabled="system_selected == null" v-on:click="next" :style="{ 'background-color': system_selected == null ? 'rgba(0, 128, 0, 0.5)' : '' , 'border-color': system_selected == null ? 'rgba(0, 128, 0, 0.5)' : '' }">Modifier</button>
            </div>
        </form>
<!-- ######################################################################################### -->
        
        <b-modal ref="updateSystem_popup" hide-footer centered no-close-on-backdrop hide-header-close v-bind:title="'Modifier l\'outil'" >
            <v-update-system
                :selected_system="this.system_selected"
                @update-system-done = "close_updateSystem"
            ></v-update-system>
        </b-modal>
    </div>
</template>

<script>
    //import api from "../../config/_api";
    import { mapGetters } from 'vuex';
    import UpdateSystem from "../../components/System/UpdateSystem.vue";
    //import { mapMutations } from 'vuex';
    //import adherents from "../../store/modules/adherents";

    export default {
        name: "Edit",
        components:{
            'v-update-system': UpdateSystem,
        },

        data () {
            return {
                system_selected: null,
                stateForm: 0,
                error: false,
            }
        },
        computed: {
            ...mapGetters({
                systems: 'systems/systems',
                adherents: 'adherents/adherents',
            }),
        },
        mounted() {
            this.$store.dispatch('systems/getSystems');
            this.$store.dispatch('adherents/getUtilisateurs');
        },
        methods: {
            close_updateSystem() {
                this.$refs.updateSystem_popup.hide();
                this.system_selected = null;
                this.stateForm = 0;
            },
            next() {
                this.stateForm = 1;
                this.$refs.updateSystem_popup.show();
            },
        }
    }
</script>

<style scoped>

</style>